import React from "react";
import { Link, useNavigate } from "react-router-dom";

function PageNotFound() {
  const navigate = useNavigate();

  return (
    <div className="main-wrapper">
      <div className="error-box">
        <div className="error-img">
          <img
            src={`${process.env.PUBLIC_URL}/img/authentication/error-404.png`}
            className="img-fluid"
            alt="Img"
          />
        </div>
        <h3 className="h2 mb-3">Oops, something went wrong</h3>
        <p>
          Error 404 Page not found. Sorry the page you looking for doesn’t exist
          or has been moved
        </p>
        <Link className="btn btn-primary" onClick={() => navigate(-1)}>
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default PageNotFound;
